import { render, staticRenderFns } from "./zyywtop.vue?vue&type=template&id=5698eb48&scoped=true&"
import script from "./zyywtop.vue?vue&type=script&lang=js&"
export * from "./zyywtop.vue?vue&type=script&lang=js&"
import style0 from "./zyywtop.vue?vue&type=style&index=0&id=5698eb48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5698eb48",
  null
  
)

export default component.exports